import { render, staticRenderFns } from "./ProxiesTcp.vue?vue&type=template&id=7b2e90dc&"
import script from "./ProxiesTcp.vue?vue&type=script&lang=js&"
export * from "./ProxiesTcp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports